import type { ArticleSource } from '../data/glossary-articles';

interface ArticleSourcesProps {
  sources: ArticleSource[];
}

// The pages an article's facts come from. The same list is the article's
// JSON-LD `citation` (KnowledgeArticle.tsx).
export default function ArticleSources({ sources }: ArticleSourcesProps) {
  return (
    <section aria-labelledby="sources" className="mt-16 pt-12 border-t border-white/10">
      <h2 id="sources" className="font-serif text-2xl mb-6">Sources</h2>
      <ol className="list-decimal pl-6 space-y-3 text-secondary text-sm leading-relaxed marker:text-white/40">
        {sources.map((source) => (
          <li key={source.url}>
            <a
              href={source.url}
              className="text-blue-400 hover:text-blue-300 underline underline-offset-4 decoration-blue-400/30 break-words"
            >
              {source.title}
            </a>
            <span className="text-white/55"> — {source.publisher}</span>
          </li>
        ))}
      </ol>
    </section>
  );
}
